<template >

  <div>

      <v-dialog v-model="dialog3" persistent max-width="80%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE DESPACHO</h4>
            </div>

            <h5
              class="headline mb-0 text-center"
            >RECONOCIMIENTO PERSONERÍA JURÍDICA FAMILIAR Y/O ALLEGADO</h5>
            <section class="my-5 section-preview">
              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItemAllegado.abogado_reconocido_victima_principal"
                    :items="abogado_reconocido_victima_principal"
                    label="¿El abogado reconocido es el mismo de la víctima principal?"
                    item-text="Indique sí el abogado reconocido es el mismo que presentó la víctima principal"
                    item-value="Indique sí el abogado reconocido es el mismo que presentó la víctima principal"
                    :rules="requiredRules"
                  ></v-select>
                </div>
              </div>

              <div
                v-if="editedItemAllegado.abogado_reconocido_victima_principal === 'No'"
                class="h1-responsive my-5"
                style="display:flex; justify-content: space-between"
              >
                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItemAllegado.reconocimiento_personeria_juridica_allegado"
                    :items="reconocimiento_personeria_juridica"
                    label="Reconocimiento personería jurídica"
                    item-text="Reconocimiento personería jurídica"
                    item-value="Reconocimiento personería jurídica"
                    :rules="requiredRules"
                  ></v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu
                    v-model="menu_fecha_auto_reconocimiento_personeria_juridica_allegado"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedItemAllegado.fecha_auto_reconocimiento_personeria_juridica_allegado"
                        label="Fecha auto de reconocimiento de personería jurídica"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="editedItemAllegado.fecha_auto_reconocimiento_personeria_juridica_allegado"
                      @input="menu_fecha_auto_reconocimiento_personeria_juridica_allegado = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>

              <div
                v-if="editedItemAllegado.abogado_reconocido_victima_principal === 'No' && editedItemAllegado.reconocimiento_personeria_juridica_allegado === 'Reconocida'"
              >
                <v-divider class="mx-1"></v-divider>
                <label>Nombre del abogado reconocido:</label>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Primer nombre"
                      v-model="editedItemAllegado.nombre_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Segundo nombre"
                      v-model="editedItemAllegado.nombre2_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>
                </div>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Primer apellido"
                      v-model="editedItemAllegado.apellido1_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Segundo apellido"
                      v-model="editedItemAllegado.apellido2_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>
                </div>

                <v-divider class="mx-1"></v-divider>
                <label>Datos de contacto del abogado reconocido:</label>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Dirección de notificación"
                      v-model="editedItemAllegado.direccion_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Teléfono de contacto"
                      v-model="editedItemAllegado.telefono_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>
                </div>

                <div
                  class="h1-responsive my-5"
                  style="display:flex; justify-content: space-between"
                >
                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Celular de contacto"
                      v-model="editedItemAllegado.celular_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-text-field
                      label="Correo electrónico"
                      v-model="editedItemAllegado.correo_abogado_reconocido_allegado"
                    ></v-text-field>
                  </div>
                </div>
              </div>

              <v-divider class="mx-1"></v-divider>

              <v-textarea
                v-if="editedItemAllegado.abogado_reconocido_victima_principal === 'No'"
                v-model="editedItemAllegado.auto_reconocimiento_personeria_juridica_allegado"
                label="Auto reconocimiento personería jurídica:"
                hint="Brinde por favor la información correspondiente al auto de reconocimiento de personería jurídica."
              ></v-textarea>
            </section>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog3 = false">Cancelar</v-btn>
            <v-btn color="primary" @click="updateReconocimientoPesonaJuridicaAllegado(editedItemAllegado, 0)" v-if="boton_guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <div>

      <v-layout>
        <v-alert :value="true" type="warning">
          Por favor, recuerde que el diligenciamiento del Formulario y la solicitud de acreditación ante la JEP es de carácter GRATUITO. La acreditación como víctima dentro del caso tiene como objetivo participar como interviniente especial en el Caso 01 y que EN NINGÚN CASO implicará el pago de indemnizaciones por parte de la Jurisdicción Especial para la Paz.
        </v-alert>
      </v-layout>

      <v-layout>
         <v-card>
           <v-card-text>
             <div><label>Manifestación de consentimiento:</label></div>
             “De conformidad a lo establecido en el artículo 3 de la Ley 1922 de 2018, al llenar y enviar el siguiente Formulario en línea de Solicitud de Acreditación manifiesto mi voluntad de ser reconocido/a como víctima dentro del Caso No. 01 - "Retención ilegal de personas cometidas por parte de antiguas FARC-EP", que adelanta la Sala de Reconocimiento de Verdad y Responsabilidad, y certifico que la información aquí consignada es verdadera.
             <v-radio-group v-model="editedItem.disclaimer" :rules="requiredRules" row>
               <v-radio label="Si" value="Si"></v-radio>
               <v-radio label="No" value="No" @click="return_portal"></v-radio>
             </v-radio-group>

           </v-card-text>
         </v-card>
       </v-layout>
    </div>

    <div v-if="editedItem.disclaimer=='Si'">

      <v-stepper v-model="step" vertical class="estilo_jep">

        <v-layout style="background-color:#b121f;">
          <v-flex fixed style="background-color:#b121f;">
            <div style="position:sticky;" >
              <v-stepper-header style="background-color:#b121f;">
                <v-stepper-step editable step="1" :complete="step > 1">Información personal</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step editable step="2" :complete="step > 2">Hechos victimizantes</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step  editable step="3" :complete="step > 3">Familiares y allegados</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step editable step="4" :complete="step > 4">Representación judicial</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step  editable step="5" :complete="step > 5">Protección y seguridad</v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step  editable step="6" :complete="step > 6">Verificar</v-stepper-step>
              </v-stepper-header>
            </div>
          </v-flex>
        </v-layout>

        <!-- <v-divider class="mx-1"></v-divider> -->

        <v-stepper-items>

          <!-- Paso 1 -->
          <v-stepper-content step="1">
            <v-form ref="form_step_1" v-model="valid" lazy-validation>

              <v-divider class="mx-1"></v-divider>
              <label>¿Ha presentado con anterioridad una solicitud de acreditación como víctima ante la Jurisdicción Especial para la Paz? </label>
              <v-radio-group v-model="editedItem.solicitud_anterior" row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <v-divider class="mx-1"></v-divider>
              <label>¿Llena usted por sí mismo este formulario? </label>
              <v-radio-group v-model="editedItem.formulario_propio"  row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <!-- // Si marco No respuesta anterior -->
              <div v-if="editedItem.formulario_propio=='No'">

                <v-alert :value="true" type="warning">
                  Tenga en cuenta: El diligenciamiento del formulario y la solicitud de acreditación ante la JEP es de carácter GRATUITO
                </v-alert>

                <label>Por favor indique el nombre de la persona que le está ayudando con este Formulario: </label>
                <v-text-field label="Nombre completo" v-model="editedItem.persona_victima" ></v-text-field>
                <label>Por favor indique la calidad de la persona que le ayuda a diligenciar este formulario: </label>

                <v-select v-model="editedItem.calidad_ayuda" :items="calidades_ayuda" label="Calidad de persona que le ayuda" prepend-icon="fas fa-map" item-text="nombre" item-value="nombre" chips>
                </v-select>
              </div>

              <v-divider class="mx-1"></v-divider>
              <label>Si tiene un registro ante el Registro Único de Víctimas, por favor indíquelo </label>
              <v-text-field label="Registro" v-model="editedItem.no_registro_victima" ></v-text-field>

              <v-divider class="mx-1"></v-divider>
              <label>Nombre de la víctima solicitante: </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Primer nombre * obligatorio" v-model="editedItem.nombre_victima_solicitante" :rules="requiredRules"></v-text-field>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Segundo nombre" v-model="editedItem.nombre2_victima_solicitante" ></v-text-field>
                </div>

              </div>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Primer apellido * obligatorio" v-model="editedItem.apellido1_victima_solicitante" :rules="requiredRules"></v-text-field>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Segundo apellido" v-model="editedItem.apellido2_victima_solicitante" ></v-text-field>
                </div>

              </div>

              <v-divider class="mx-1"></v-divider>
              <label>Documento de identidad de la víctima solicitante: </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select v-model="editedItem.tipos_documentos_id" :items="tipo_documentos" label="Tipo de documento * obligatorio" item-text="nombre" item-value="id" :rules="requiredRules">
                  </v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Número de documento * obligatorio" @change="verifica_identificacion" v-model="editedItem.no_identificacion" :rules="requiredRules" ></v-text-field>
                </div>

              </div>

              <v-divider class="mx-1"></v-divider>
              <label>Información nacimiento de la víctima solicitante: </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">

                  <v-autocomplete
                    v-model="editedItem.departamento_nacimiento_id"
                    :items="src_departamentos_nacimiento"
                    label="Departamento nacimiento * obligatorio"
                    item-text="nombre"
                    item-value="id"
                    :rules="requiredRules"
                    @change="trae_municipio_nacimiento"
                    hint="Escoja del desplegable el departamento que corresponda al lugar de nacimiento "
                  >
                    <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                  </v-autocomplete>

                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-autocomplete
                    v-model="editedItem.municipio_nacimiento_id"
                    :items="src_municipios_nacimiento"
                    label="Municipio nacimiento  * obligatorio"
                    item-text="nombre"
                    item-value="id"
                    :rules="requiredRules"
                    hint="Escoja del desplegable el municipio que corresponda al lugar de nacimiento "
                  >
                    <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                  </v-autocomplete>
                </div>

              </div>

              <div class="estilo_dos_columnas" style="padding-left:0px;">
                <v-menu v-model="menu_fecha_nacimiento" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="editedItem.fecha_nacimiento" label="Seleccione la fecha de nacimiento" prepend-icon="event" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="editedItem.fecha_nacimiento" @input="menu_fecha_nacimiento = false"></v-date-picker>
                </v-menu>
              </div>

              <v-divider class="mx-1"></v-divider>
              <label>Dirección residencia actual: </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">

                  <v-autocomplete
                    v-model="editedItem.departamento_id"
                    :items="src_departamentos"
                    label="Departamento residencia actual * obligatorio"
                    item-text="nombre"
                    item-value="id"
                    :rules="requiredRules"
                    @change="trae_municipio"
                    hint="Escoja del desplegable el departamento que corresponda al lugar de residencia "
                  >
                    <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                  </v-autocomplete>

                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-autocomplete
                    v-model="editedItem.municipio_id"
                    :items="src_municipios"
                    label="Municipio residencia actual * obligatorio"
                    item-text="nombre"
                    item-value="id"
                    :rules="requiredRules"
                    hint="Escoja del desplegable el municipio que corresponda al lugar de residencia "
                  >
                    <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                  </v-autocomplete>
                </div>

              </div>

              <v-text-field label="Dirección: * obligatorio" :rules="requiredRules" v-model="editedItem.direccion" ></v-text-field>

              <v-divider class="mx-1"></v-divider>
              <label>Datos de contacto: </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Correo electrónico * obligatorio" v-model="editedItem.correo" :rules="[rules.email]"></v-text-field>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Verifique Correo electrónico * obligatorio" @paste.prevent @change="email_igual" :rules="[rules.email]" v-model="editedItem.correo_verificar"></v-text-field>
                </div>

              </div>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-select
                    v-model="editedItem.indicativo"
                    :items="indicativos"
                    label="Indicativo de ciudad para teléfono"
                  >
                  </v-select>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-text-field label="Número de teléfono fijo * obligatorio" v-model="editedItem.telefono_fijo" :rules="requiredRules"></v-text-field>
                </div>

              </div>

              <v-text-field label="Número de teléfono celular * obligatorio" v-model="editedItem.telefono_celular" :rules="requiredRules"></v-text-field>

              <v-divider class="mx-1"></v-divider>
              <label>Ocupación actual: </label>
              <v-text-field label="Ocupación actual" v-model="editedItem.ocupacion_actual" ></v-text-field>

              <v-divider class="mx-1"></v-divider>
              <label>¿Pertenece usted a algún pueblo, comunidad indígena, Rrom, negra, afrocolombiana, raizal o palenquera?</label>
              <v-radio-group v-model="editedItem.grupo_etnico" row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <!-- // Si marco Si respuesta anterior -->
              <div v-if="editedItem.grupo_etnico=='Si'">
                <label> Por favor, indique a qué pueblo, comunidad indígena, Rrom, negra, afrocolombiana, raizal o palenquera pertenece: </label>
                <v-text-field label="Nombre grupo étnico" v-model="editedItem.nombre_grupo_etnico" ></v-text-field>
              </div>

              <v-divider class="mx-1"></v-divider>
              <label>¿Pertenece usted a alguna organización de víctimas?</label>
              <v-radio-group v-model="editedItem.organizacion_victimas" row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <!-- // Si marco Si respuesta anterior -->
              <div v-if="editedItem.organizacion_victimas=='Si'">
                <label>Por favor indique el nombre de la organización de víctimas a la que pertenece: </label>
                <v-text-field label="Nombre organización victimas" v-model="editedItem.nombre_organizacion_victimas" ></v-text-field>
              </div>

              <v-divider class="mx-1"></v-divider>
              <label>¿Pertenece usted a un sujeto colectivo que desea acreditarse como víctima?</label>
              <v-radio-group v-model="editedItem.sujeto_colectivo" row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <!-- // Si marco Si respuesta anterior -->
              <div v-if="editedItem.sujeto_colectivo=='Si'">
                <label>Por favor indique el nombre del sujeto colectivo al que pertenece: </label>
                <v-text-field label="Nombre sujeto colectivo" v-model="editedItem.nombre_sujeto_colectivo" ></v-text-field>
              </div>

              <v-divider class="mx-1"></v-divider>

              <v-btn color="primary" @click="validate($refs.form_step_1,2)">Siguiente</v-btn>

            </v-form>

          </v-stepper-content>

          <!--  Paso 2 -->
          <v-stepper-content step="2">

            <v-form ref="form_step_2" v-model="valid" lazy-validation >

              <v-divider class="mx-1"></v-divider>
              <label>Esta solicitud de acreditación la hago en razón de los siguientes hechos victimizantes:  </label>

              <v-textarea
                v-model="editedItem.hecho_victimizante"
                label="Relate los hechos:"
                hint="Brinde por favor un relato tan detallado como sea posible de los hechos, especificando su fecha, lugar de ocurrencia e información sobre presuntos responsables. Si desea en el siguiente campo puede adjuntar un documento con el relato de los hechos."
              ></v-textarea>

              <v-alert color="blue-grey" style="display:block">
                <cargar-documento documento="Adjunto Hechos victimizantes" tipo="HV" :index=0></cargar-documento>
                <label>En caso que sean varias hojas debe agruparlas en un solo PDF.</label>
              </v-alert>

              <v-divider class="mx-1"></v-divider>
              <label>Indique si la/s víctima/s directa/s fueron dadas por desaparecidas:</label>
              <v-radio-group v-model="editedItem.victima_desaparecida" row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <v-divider class="mx-1"></v-divider>
              <label>Información fecha de los hechos victimizantes:  </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu v-model="menu_fecha_inicio_contrato" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="editedItem.fecha_hechos_inicio" label="Seleccione la fecha de inicio de los hechos" prepend-icon="event" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.fecha_hechos_inicio" @input="menu_fecha_inicio_contrato = false"></v-date-picker>
                  </v-menu>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-menu v-model="menu_fecha_fin_contrato" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="editedItem.fecha_hechos_fin" label="Seleccione la fecha de fin de los hechos" prepend-icon="event" readonly v-on="on" ></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.fecha_hechos_fin" @input="menu_fecha_fin_contrato = false"></v-date-picker>
                  </v-menu>
                </div>

              </div>

              <v-divider class="mx-1"></v-divider>
              <label>Información del lugar de los hechos victimizantes:  </label>

              <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-autocomplete
                    v-model="editedItem.departamento_hechos_id"
                    :items="src_departamentos_hechos"
                    label="Departamento del lugar de los hechos"
                    item-text="nombre"
                    item-value="id"
                    @change="trae_municipio_hechos"
                    hint="Escoja del desplegable el departamento que corresponda al lugar de los hechos"
                  ></v-autocomplete>
                </div>

                <div class="estilo_dos_columnas" style="padding-left:0px;">
                  <v-autocomplete
                    v-model="editedItem.municipio_hechos_id"
                    :items="src_municipios_hechos"
                    label="Municipio del lugar de los hechos"
                    item-text="nombre"
                    item-value="id"
                    hint="Escoja del desplegable el municipio que corresponda al lugar de los hechos"
                  ></v-autocomplete>
                </div>

              </div>

              <v-textarea
              v-model="editedItem.lugar_hechos"
              label="Lugar de los hechos"
              hint="Si es posible, por favor, especifique el lugar exacto (corregimiento, vía, vereda, municipio, departamento en que tuvieron ocurrencia los hechos. Si es posible, en una hoja anexa, dibuje el lugar de ubicación exacta que complemente y permita determinar el lugar exacto de ocurrencia"
              ></v-textarea>

              <v-alert color="blue-grey" style="display:block">
                <cargar-documento documento="Lugar de los hechos" tipo="lh" :index=0></cargar-documento>
                <label>En caso que sean varias hojas debe agruparlas en un solo PDF.</label>
              </v-alert>

              <v-divider class="mx-1"></v-divider>
              <label>Presuntos responsables:  </label>


              <div v-for="(item, index) in editedItem.presuntos_responsables" :key="index">

                <v-alert color="#2A3B4D" style="display:block">

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                    <label>Datos del presunto responsables # {{index + 1}}:  </label>
                    <v-btn color="danger" @click="less_pres_resp(index)">x</v-btn>
                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Primer nombre" v-model="item.nombre_responsable" required></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Segundo nombre" v-model="item.nombre2_responsable" required></v-text-field>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Primer apellido" v-model="item.apellido1_responsable" required></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Segundo apellido" v-model="item.apellido2_responsable" required></v-text-field>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Alias" v-model="item.alias_responsable" required></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-select v-model="item.bloque_id" clearable :items="src_bloques" label="Bloque" item-text="nombre" item-value="id"></v-select>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-select v-model="item.frente_id" clearable :items="src_frentes" label="Frente" item-text="nombre" item-value="id"></v-select>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="¿Cúal?" v-if="item.frente_id==81" v-model="item.otro" required></v-text-field>
                    </div>

                  </div>

                  <v-textarea
                    v-model="item.observaciones"
                    label="Información adicional"
                    hint="Diligencie este campo si considera que debe indicar más de un bloque o frente y las razones para hacerlo."
                  ></v-textarea>

                </v-alert>

              </div>

              <v-spacer></v-spacer>
              <v-alert color="blue-grey" style="display:block">
                <v-btn color="info" @click="add_pres_resp">+</v-btn>
                <v-spacer></v-spacer>
                <label>Clic para agregar tantos presuntos responsables como requiera.</label>
              </v-alert>

              <v-divider class="mx-1"></v-divider>
              <label>Algunos documentos que dan cuenta de los hechos que estoy reportando en donde consta que he sido víctima, son: (Incluya documentos como copia de inclusión en el RUV, denuncias ante otras instituciones, sentencias en donde haya sido reconocido(a) como víctima, entre otros).</label>

              <template v-for="(item, index) in adjuntar_documentos">
                <v-alert color="#2A3B4D" style="display:block" :key="index">
                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                      <cargar-documento documento="Adjunto" :tipo="index" :index=index></cargar-documento>
                      <v-btn color="danger" @click="less_documentos(index)">-</v-btn>
                  </div>
                </v-alert>
              </template>

              <v-spacer></v-spacer>
              <v-alert color="blue-grey" style="display:block">
                <v-btn color="info" @click="add_documentos">+</v-btn>
                <v-spacer></v-spacer>
                <label>Clic para agregar tantos documentos como requiera.</label>
              </v-alert>

              <v-divider class="mx-1"></v-divider>

              <v-btn flat @click.native="step = 1">Anterior</v-btn>
              <v-btn color="primary" @click="validate($refs.form_step_2,3)">Siguiente</v-btn>

            </v-form>

          </v-stepper-content>

          <!-- Paso 3 -->
          <v-stepper-content step="3">

            <v-form ref="form_step_3" v-model="valid" lazy-validation>

              <v-divider class="mx-1"></v-divider>

              <label>Solicito que también sean reconocidos como víctimas los siguientes miembros de mi familia y/o allegados, para lo cual adjunto los siguientes registros civiles y/o pruebas que acreditan el daño por ellos sufrido en razón de los hechos victimizantes descritos: </label>
              <v-alert color="info" style="display:block">
                Por favor, indique los datos personales completos de sus familiares y/o allegados, así como los registros civiles y otra documentación aportada
              </v-alert>

              <div v-for="(item, index) in editedItem.allegados_familiares" :key="index">

                <v-alert color="#2A3B4D" style="display:block">

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                    <label>Datos del familiar o allegado # {{index + 1}}:  </label>
                    <v-btn color="danger" @click="less_allegados(index)">-</v-btn>
                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Primer nombre" v-model="item.nombre_allegado" required></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Segundo nombre" v-model="item.nombre2_allegado" required></v-text-field>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Primer apellido" v-model="item.apellido1_allegado" required></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Segundo apellido" v-model="item.apellido2_allegado" required></v-text-field>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Documento" v-model="item.documento_allegado" required></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Parentesco" v-model="item.parentezco_allegado" required></v-text-field>
                    </div>

                  </div>

                  <cargar-documento documento="Adjuntar documento" :tipo="item.nombre_allegado" :index=0 ></cargar-documento>

                </v-alert>

              </div>

              <v-spacer></v-spacer>
              <v-alert color="blue-grey" style="display:block">
                <v-btn color="info" @click="add_allegados">+</v-btn>
                <v-spacer></v-spacer>
                <label>Clic para agregar tantos familiares o allegados como requiera.</label>
              </v-alert>

              <v-divider class="mx-1"></v-divider>
              <label>Si desea adjuntar documentos adicionales de sus familiares o allegados, por favor adjuntelos a continuación:</label>

              <template v-for="(item, index) in adjuntar_documentos_fa">
                <v-alert color="#2A3B4D" style="display:block" :key="index">
                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">
                    <cargar-documento documento="Adjuntar documento" :tipo="index" :index=index ></cargar-documento>
                    <v-btn color="danger" @click="less_documentos_fa(index)">-</v-btn>
                  </div>
                </v-alert>
              </template>

              <v-spacer></v-spacer>
              <v-alert color="blue-grey" style="display:block">
                <v-btn color="info" @click="add_documentos_fa">+</v-btn>
                <v-spacer></v-spacer>
                <label>Clic para agregar tantos documentos como requiera.</label>
              </v-alert>

              <v-divider class="mx-1"></v-divider>

              <v-btn flat @click.native="step = 2">Anterior</v-btn>
              <v-btn color="primary" @click.native="step = 4">Siguiente</v-btn>

            </v-form>

          </v-stepper-content>

          <!-- Paso 4 -->
          <v-stepper-content step="4">

            <v-form ref="form_step_4" v-model="valid" lazy-validation>

              <h5 class="headline mb-0 text-center">
                REPRESENTACIÓN JUDICIAL
              </h5>

              <section class="my-5 section-preview">

                <label>¿Cuenta usted con un abogado de confianza que lo represente en el proceso?</label>
                <v-radio-group v-model="editedItem.abogado_confianza" row>
                  <v-radio label="Si" value="Si"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>

                <!-- // Si marco Si respuesta anterior -->
                <div v-if="editedItem.abogado_confianza=='Si'">

                  <v-divider class="mx-1"></v-divider>
                  <label>Nombre del abogado:</label>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Primer nombre" v-model="editedItem.nombre_abogado" ></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Segundo nombre" v-model="editedItem.nombre2_abogado" ></v-text-field>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Primer apellido" v-model="editedItem.apellido1_abogado" ></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Segundo apellido" v-model="editedItem.apellido2_abogado" ></v-text-field>
                    </div>

                  </div>

                  <v-divider class="mx-1"></v-divider>
                  <label>Datos de contacto del abogado:</label>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Dirección de notificación" v-model="editedItem.direccion_abogado" ></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Teléfono de contacto" v-model="editedItem.telefono_abogado" ></v-text-field>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between">

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Celular de contacto" v-model="editedItem.celular_abogado" ></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field label="Correo electrónico" v-model="editedItem.correo_abogado" ></v-text-field>
                    </div>

                  </div>

                  <v-divider class="mx-1"></v-divider>
                  <label>¿Anexa poder especial?</label>
                  <v-radio-group v-model="editedItem.poder_abogado" row>
                    <v-radio label="Si" value="Si"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                  </v-radio-group>

                  <v-alert color="blue-grey" style="display:block" v-if="editedItem.poder_abogado == 'Si'">
                    <cargar-documento documento="Adjunto poder abogado" tipo="Abogado" :index=0></cargar-documento>
                    <label>En caso que sean varias hojas debe agruparlas en un solo PDF.</label>
                  </v-alert>

                </div>

                <!-- // Si marco No respuesta anterior -->
                <div v-if="editedItem.abogado_confianza=='No'">

                  <v-divider class="mx-1"></v-divider>
                  <label>¿Esta siendo representado/a actualmente por un abogado del Sistema Autónomo de Asesoría y Representación Legal de la JEP?</label>
                  <v-radio-group v-model="editedItem.representado_actualmente_jep" row>
                    <v-radio label="Si" value="Si"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                  </v-radio-group>

                </div>

                <div v-if="editedItem.abogado_confianza=='No' && editedItem.representado_actualmente_jep=='Si'">

                  <v-divider class="mx-1"></v-divider>
                  <label>Nombre del abogado</label>
                  <v-text-field label="Primer nombre" v-model="editedItem.nombre_abogado" ></v-text-field>
                  <v-text-field label="Segundo nombre" v-model="editedItem.nombre2_abogado" ></v-text-field>
                  <v-text-field label="Primer apellido" v-model="editedItem.apellido1_abogado" ></v-text-field>
                  <v-text-field label="Segundo apellido" v-model="editedItem.apellido2_abogado" ></v-text-field>
                  <v-text-field label="Dirección de notificación" v-model="editedItem.direccion_abogado" ></v-text-field>
                  <v-text-field label="Teléfono de contacto" v-model="editedItem.telefono_abogado" ></v-text-field>
                  <v-text-field label="Celular de contacto" v-model="editedItem.celular_abogado" ></v-text-field>
                  <v-text-field label="Correo electrónico" v-model="editedItem.correo_abogado" ></v-text-field>

                </div>

                <div v-if="editedItem.abogado_confianza=='No' && editedItem.representado_actualmente_jep=='No'">

                  <v-divider class="mx-1"></v-divider>
                  <label>¿Manifiesta su interés en ser representado/a por un abogado común del Sistema Autónomo de Asesoría y Representación Legal de la JEP?</label>
                  <v-radio-group v-model="editedItem.manifiesta_interes" row>
                    <v-radio label="Si" value="Si"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                  </v-radio-group>

                  <!-- // Si marco No respuesta anterior -->
                  <div v-if="editedItem.abogado_confianza=='No' && editedItem.representado_actualmente_jep=='No' && editedItem.manifiesta_interes=='No'">

                    <v-divider class="mx-1"></v-divider>
                    <label>¿Manifiesta su voluntad de actuar por sí mismo/a en el proceso ante la JEP?</label>
                    <v-radio-group v-model="editedItem.voluntad_actuar_solo" row>
                      <v-radio label="Si" value="Si"></v-radio>
                      <v-radio label="No" value="No"></v-radio>
                    </v-radio-group>

                    <!-- // Si marco No respuesta anterior -->
                    <div v-if="editedItem.abogado_confianza=='No' && editedItem.representado_actualmente_jep=='No' && editedItem.voluntad_actuar_solo=='No' && editedItem.voluntad_actuar_solo=='No'">
                      <v-divider class="mx-1"></v-divider>
                      <label>Por favor, indique qué otro medio de representación judicial usará:</label>
                      <v-text-field label="Medio de representación" v-model="editedItem.medio_representacion" ></v-text-field>
                    </div>
                  </div>

                </div>
              </section>

              <h5 class="headline mb-0 text-center">
                RECONOCIMIENTO PERSONERÍA JURÍDICA VÍCTIMA PRINCIPAL
              </h5>

              <section class="my-5 section-preview">
                <label>¿Cuenta usted con un abogado reconocido en el proceso?</label>

                <v-radio-group v-model="editedItem.reconocimiento_personeria_juridica" row>
                  <v-radio label="Si" value="Reconocida"></v-radio>
                  <v-radio label="No" value="No reconocida"></v-radio>
                </v-radio-group>

                <div v-if="editedItem.reconocimiento_personeria_juridica === 'Reconocida'">

                  <v-divider class="mx-1"></v-divider>
                  <label>Nombre del abogado reconocido:</label>

                  <div
                    class="h1-responsive my-5"
                    style="display:flex; justify-content: space-between"
                  >
                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field
                        label="Primer nombre"
                        v-model="editedItem.nombre_abogado_reconocido"
                      ></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field
                        label="Segundo nombre"
                        v-model="editedItem.nombre2_abogado_reconocido"
                      ></v-text-field>
                    </div>
                  </div>

                  <div
                    class="h1-responsive my-5"
                    style="display:flex; justify-content: space-between"
                  >
                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field
                        label="Primer apellido"
                        v-model="editedItem.apellido1_abogado_reconocido"
                      ></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field
                        label="Segundo apellido"
                        v-model="editedItem.apellido2_abogado_reconocido"
                      ></v-text-field>
                    </div>
                  </div>

                  <v-divider class="mx-1"></v-divider>
                  <label>Datos de contacto del abogado reconocido:</label>

                  <div
                    class="h1-responsive my-5"
                    style="display:flex; justify-content: space-between"
                  >
                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field
                        label="Dirección de notificación"
                        v-model="editedItem.direccion_abogado_reconocido"
                      ></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field
                        label="Teléfono de contacto"
                        v-model="editedItem.telefono_abogado_reconocido"
                      ></v-text-field>
                    </div>
                  </div>

                  <div
                    class="h1-responsive my-5"
                    style="display:flex; justify-content: space-between"
                  >
                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field
                        label="Celular de contacto"
                        v-model="editedItem.celular_abogado_reconocido"
                      ></v-text-field>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;">
                      <v-text-field
                        label="Correo electrónico"
                        v-model="editedItem.correo_abogado_reconocido"
                      ></v-text-field>
                    </div>
                  </div>

                  <v-divider class="mx-1"></v-divider>
                  <label>Datos de fecha y auto de reconocimiento personería jurídica:</label>

                  <div class="estilo_dos_columnas" style="padding-left:0px;">
                    <v-menu
                      v-model="menu_fecha_auto_reconocimiento_personeria_juridica"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="editedItem.fecha_auto_reconocimiento_personeria_juridica"
                          label="Fecha auto de reconocimiento de personería jurídica"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        v-model="editedItem.fecha_auto_reconocimiento_personeria_juridica"
                        @input="menu_fecha_auto_reconocimiento_personeria_juridica = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>

                  <v-divider class="mx-1"></v-divider>

                  <v-textarea
                    v-model="editedItem.auto_reconocimiento_personeria_juridica"
                    label="Auto reconocimiento personería jurídica:"
                    hint="Brinde por favor la información correspondiente al auto de reconocimiento de personería jurídica."
                  ></v-textarea>

                </div>
              </section>

              <h5 class="headline mb-0 text-center">
                RECONOCIMIENTO PERSONERÍA JURÍDICA FAMILIARES Y/0 ALLEGADOS
              </h5>

              <section class="my-5 section-preview">
                <span v-if="editedItem.allegados_familiares.length">
                  <div v-for="(item, index) in editedItem.allegados_familiares" :key="index">
                    <v-alert color="blue-grey" style="display:block">
                      <div
                        class="h1-responsive text-uppercase"
                        style="display:flex; justify-content: space-between;"
                      >
                        <div class="estilo_tres_columnas" style="padding-left:0px;">
                          <v-badge color="blue-grey darken-2">
                            <template v-slot:badge>{{index + 1}}.</template>
                          </v-badge>
                          <span
                            v-if="item.documento_allegado"
                            style="padding-left:25px;"
                          >Número documento: {{item.documento_allegado}}</span>
                          <span
                            v-if="item.parentezco_allegado"
                            style="padding-left:28px;"
                          >Parentesco: {{item.parentezco_allegado}}</span>
                        </div>

                        <div class="estilo_tres_columnas text-center" style="padding-left:0px;">
                          <span
                            v-if="item.nombre_allegado || item.nombre2_allegado || item.apellido1_allegado || item.apellido2_allegado"
                          >
                            Nombre completo:
                            <br />
                          </span>
                          <span v-if="item.nombre_allegado">{{item.nombre_allegado}}</span>
                          <span v-if="item.nombre2_allegado">{{item.nombre2_allegado}}</span>
                          <span v-if="item.apellido1_allegado">{{item.apellido1_allegado}}</span>
                          <span v-if="item.apellido2_allegado">{{item.apellido2_allegado}}</span>
                        </div>

                        <div class="estilo_tres_columnas text-center" style="padding-left:0px;">
                          <span>
                            Reconocimiento personería jurídica:
                            <br />
                          </span>
                          <v-icon
                            large
                            color="green accent-4"
                            v-if="item.abogado_reconocido_victima_principal==='Sí' || (item.abogado_reconocido_victima_principal==='No' && item.reconocimiento_personeria_juridica_allegado==='Reconocida')"
                            @click="gestionDespachoReconocimientoFamiliar(index, item)"
                          >verified_user</v-icon>
                          <v-icon
                            large
                            color="red accent-4"
                            v-else-if="item.abogado_reconocido_victima_principal==='No' && item.reconocimiento_personeria_juridica_allegado==='No reconocida'"
                            @click="gestionDespachoReconocimientoFamiliar(index, item)"
                          >verified_user</v-icon>
                          <v-icon
                            large
                            color="red accent-4"
                            v-else
                            @click="gestionDespachoReconocimientoFamiliar(index, item)"
                          >verified_user</v-icon>
                        </div>
                      </div>
                    </v-alert>
                  </div>
                </span>
                <v-alert v-else color="lime darken-3" style="display:block">
                  <label>No tiene familiares ni allegados registrados</label>
                </v-alert>

              </section>

              <v-btn flat @click.native="step = 3">Anterior</v-btn>
              <v-btn color="primary" @click.native="step = 5">Siguiente</v-btn>

            </v-form>

          </v-stepper-content>

          <!-- Paso 5 -->
          <v-stepper-content step="5">

            <v-form ref="form_step_5" v-model="valid" lazy-validation>

              <v-divider class="mx-1"></v-divider>
              <label>¿Las víctimas solicitantes tienen alguna razón para temer por su seguridad, integridad, dignidad o bienestar actualmente, o identifica riesgos por el inicio de este proceso de acreditación ante la Jurisdicción Especial para la Paz?</label>
              <v-radio-group v-model="editedItem.riesgo_seguridad" row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <!-- // Si marco Si respuesta anterior -->
              <div v-if="editedItem.riesgo_seguridad=='Si'">
                <v-textarea
                  v-model="editedItem.razones_riesgo_seguridad"
                  label="¿Cuáles son las razones? "
                ></v-textarea>
              </div>

              <v-divider class="mx-1"></v-divider>
              <label>¿La víctima solicitante o sus familiares y/o allegados tienen alguna razón para temer por la seguridad o integridad o algún riesgo sobre la información, archivos, objetos o lugares que puedan representar interés probatorio o de información de contexto para el inicio de este proceso de acreditación ante la Jurisdicción Especial para la Paz?</label>
              <v-radio-group v-model="editedItem.riesgo_seguridad_pruebas" row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <!-- // Si marco Si respuesta anterior -->
              <div v-if="editedItem.riesgo_seguridad_pruebas=='Si'">
                <v-textarea
                  v-model="editedItem.razones_riesgo_seguridad_pruebas"
                  label="¿Cuáles son las razones? "
                ></v-textarea>
              </div>

              <v-divider class="mx-1"></v-divider>
              <label>¿Autoriza a ser notificado de las actuaciones de este caso por medios electrónicos?</label>
              <v-radio-group v-model="editedItem.autoriza_notificacion" row>
                <v-radio label="Si" value="Si"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>

              <v-divider class="mx-1"></v-divider>

              <v-btn flat @click.native="step = 4">Anterior</v-btn>
              <v-btn color="primary"  @click.native="step = 6">Previsualizar</v-btn>

            </v-form>

          </v-stepper-content>

          <!-- Paso 6 -->
          <v-stepper-content step="6">

            <v-form ref="form_step_6" v-model="valid" lazy-validation>

                <div class="text-center text-uppercase" role="alert">
                  <h1 class="font-weight-bold text-uppercase">
                      Formulario en línea de Solicitud de Acreditación como víctima del caso 01
                  </h1>
                </div>

                <hr />

                <!-- <section class="my-5" style="display: flex; justify-content: space-between;">
                  <small>
                    Fecha radicado: {{$fecha_registro}}
                  </small>
                  <small>
                    Número radicado: {{$datos["codigo_registro"]}}
                  </small>
                </section> -->

                <section class="my-5 section-preview">

                  <h2 class="h1-responsive text-center font-weight-bold text-uppercase my-5">
                    1. Información personal
                  </h2>

                  <div class="h1-responsive my-5" v-if="editedItem.solicitud_anterior">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">1.{{reinicioNumeral}}.</span> -->
                      ¿Ha presentado con anterioridad una Solicitud de Acreditación ante la Jurisdicción Especial para la Paz?
                    </span>
                    <br>
                    <span style="padding: 10px;">
                        {{editedItem.solicitud_anterior}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.no_registro_victima">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                      Si tiene un número de registro ante el Registro Único de Víctimas, por favor indíquelo
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.no_registro_victima}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.formulario_propio">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                      ¿Llena usted por sí mismo este formulario?
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.formulario_propio}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.persona_victima">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                      Por favor indique el nombre de la persona que le está ayudando con este Formulario:
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.persona_victima}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.calidad_ayuda">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                      Por favor indique la calidad de la persona que le ayuda a diligenciar este formulario:
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.calidad_ayuda}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.tipos_documentos_id || editedItem.no_identificacion">

                      <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.tipos_documentos_id">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Tipo documento de la víctima solicitante:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          <span v-for="(item_tipo_documento, index) in filteredTiposDocumentosXID" :key="index">
                            {{ item_tipo_documento.nombre }}
                          </span>
                        </span>
                      </div>

                      <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.no_identificacion">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Número de identificación de la víctima solicitante:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.no_identificacion}}
                        </span>
                      </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.nombre_victima_solicitante || editedItem.nombre2_victima_solicitante">

                      <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.nombre_victima_solicitante">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Primer nombre de la víctima solicitante:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.nombre_victima_solicitante}}
                        </span>
                      </div>

                      <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.nombre2_victima_solicitante">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Segundo nombre de la víctima solicitante:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.nombre2_victima_solicitante}}
                        </span>
                      </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.apellido1_victima_solicitante || editedItem.apellido2_victima_solicitante">

                      <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.apellido1_victima_solicitante">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Primer apellido de la víctima solicitante:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.apellido1_victima_solicitante}}
                        </span>
                      </div>

                      <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.apellido2_victima_solicitante">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Segundo apellido de la víctima solicitante:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.apellido2_victima_solicitante}}
                        </span>
                      </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.fecha_nacimiento || editedItem.departamento_nacimiento_id || editedItem.municipio_nacimiento_id">

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.departamento_nacimiento_id">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Departamento nacimiento
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{departamento_nacimiento_nombre}}
                      </span>
                    </div>

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.municipio_nacimiento_id">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Municipio nacimiento
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{municipio_nacimiento_nombre}}
                      </span>
                    </div>

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.fecha_nacimiento">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Fecha nacimiento
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.fecha_nacimiento}}
                      </span>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.grupo_etnico || editedItem.nombre_grupo_etnico">

                    <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.grupo_etnico">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Pertenencia a un grupo étnico:
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.grupo_etnico}}
                      </span>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.nombre_grupo_etnico">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Cuál:
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.nombre_grupo_etnico}}
                      </span>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.organizacion_victimas || editedItem.nombre_organizacion_victimas">

                    <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.organizacion_victimas">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Pertenencia a organizacion de victimas:
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.organizacion_victimas}}
                      </span>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.nombre_organizacion_victimas">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Cuál:
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.nombre_organizacion_victimas}}
                      </span>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.sujeto_colectivo || editedItem.nombre_sujeto_colectivo">

                    <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.sujeto_colectivo">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Pertenencia a un sujeto colectivo que desea acreditarse como víctima:
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.sujeto_colectivo}}
                      </span>
                    </div>

                    <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.nombre_sujeto_colectivo">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Cuál:
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.nombre_sujeto_colectivo}}
                      </span>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.direccion || editedItem.departamento_id || editedItem.municipio_id">

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.departamento_id">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Departamento residencia
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{departamento_nombre}}
                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.municipio_id">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Municipio residencia
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{municipio_nombre}}
                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.direccion">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                          Direccion residencia
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.direccion}}
                        </span>
                      </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.telefono_fijo || editedItem.telefono_celular || editedItem.correo">

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.telefono_fijo">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Teléfono fijo de residencia
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        ({{editedItem.indicativo}}) - {{editedItem.telefono_fijo}}
                      </span>
                    </div>

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.telefono_celular">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Teléfono celular
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.telefono_celular}}
                      </span>
                    </div>

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.correo">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                        Correo electrónico
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.correo}}
                      </span>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.ocupacion_actual">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">1.{{incrementarNumeral}}.</span> -->
                      Ocupación actual
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.ocupacion_actual}}
                    </span>
                  </div>

                </section>

                <section class="my-5 section-preview">

                  <h2 class="h1-responsive text-center font-weight-bold text-uppercase my-5">
                    2. Hechos victimizantes
                  </h2>

                  <div class="h1-responsive my-5" v-if="editedItem.hecho_victimizante">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                      Esta solicitud de acreditación la hago en razón de los siguientes hechos victimizantes:
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.hecho_victimizante}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.victima_desaparecida">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                      Indique si la/s víctima/s directa/s  fueron dadas por desaparecidas:
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.victima_desaparecida}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.departamento_hechos_id || editedItem.municipio_hechos_id || editedItem.lugar_hechos">

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.departamento_hechos_id">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                          Departamento de los hechos
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{departamento_hechos_nombre}}
                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.municipio_hechos_id">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                          Municipio de los hechos
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{municipio_hechos_nombre}}
                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.lugar_hechos">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                          Lugar de los hechos
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.lugar_hechos}}
                        </span>
                      </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.fecha_hechos_inicio || editedItem.fecha_hechos_fin">

                      <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.fecha_hechos_inicio">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                          Fecha inicio de los hechos:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.fecha_hechos_inicio}}
                        </span>
                      </div>

                      <div class="estilo_dos_columnas" style="padding-left:0px;" v-if="editedItem.fecha_hechos_fin">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">2.{{incrementarNumeral}}.</span> -->
                          Fecha fin de los hechos:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.fecha_hechos_fin}}
                        </span>
                      </div>

                  </div>

                </section>

                <section class="my-5 section-preview">

                  <h2 class="h1-responsive text-center font-weight-bold text-uppercase my-5">
                    3. Presuntos responsables
                  </h2>

                  <div class="h1-responsive my-5" style="display:flex; flex-wrap: wrap" v-if="editedItem.presuntos_responsables">

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-for="(item, index) in editedItem.presuntos_responsables" :key="index">
                      <v-card
                        :flat="true"
                        :outlined="true"
                        :raised="true"
                      >
                        <v-card-title>Presunto Responsable {{index + 1}}</v-card-title>
                        <v-card-text>

                          <div v-if="item.nombre_responsable || item.nombre2_responsable || item.apellido1_responsable || item.apellido2_responsable">
                            <span class="font-weight-bold text-uppercase">
                              Nombre:
                            </span>
                            <span>

                              {{item.nombre_responsable}}

                              <span v-if="item.nombre2_responsable">
                                {{" " + item.nombre2_responsable}}
                              </span>

                              {{" " + item.apellido1_responsable}}

                              <span v-if="item.apellido2_responsable">
                                {{" " + item.apellido2_responsable}}
                              </span>

                            </span>
                            <br>
                          </div>

                          <div v-if="item.alias_responsable">
                            <span class="font-weight-bold text-uppercase">
                              Alias:
                            </span>
                            <span>
                              {{item.alias_responsable}}
                            </span>
                            <br>
                          </div>

                          <div v-if="item.bloque_id">
                            <span class="font-weight-bold text-uppercase">
                              Bloque:
                            </span>
                            <span>
                              {{obtenerNombreBloque(item.bloque_id)}}
                            </span>
                            <br>
                          </div>

                          <div v-if="item.frente_id">
                            <span class="font-weight-bold text-uppercase">
                              Frente:
                            </span>
                            <span>
                              {{obtenerNombreFrente(item.frente_id)}}
                            </span>
                            <br>
                            <br>
                          </div>

                          <div v-if="item.observaciones">
                            <span class="font-weight-bold text-uppercase">
                              Información adicional:
                            </span>
                            <p class="card-text text-justify">
                              {{item.observaciones}}
                            </p>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>

                  </div>

                </section>

                <section class="my-5 section-preview">

                  <h2 class="h1-responsive text-center font-weight-bold text-uppercase my-5">
                    4. Familiares / Allegados
                  </h2>

                  <div class="h1-responsive my-5" style="display:flex; flex-wrap: wrap" v-if="editedItem.allegados_familiares">

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-for="(item, index) in editedItem.allegados_familiares" :key="index">
                      <v-card
                        :flat="true"
                        :outlined="true"
                        :raised="true"
                      >
                        <v-card-title>Familiar o allegado {{index + 1}}</v-card-title>
                        <v-card-text>

                          <div v-if="item.nombre_allegado || item.nombre2_allegado || item.apellido1_allegado || item.apellido2_allegado">
                            <span class="font-weight-bold text-uppercase">
                              Nombre:
                            </span>
                            <span>

                              {{item.nombre_allegado}}

                              <span v-if="item.nombre2_allegado">
                                {{" " + item.nombre2_allegado}}
                              </span>

                              {{" " + item.apellido1_allegado}}

                              <span v-if="item.apellido2_allegado">
                                {{" " + item.apellido2_allegado}}
                              </span>

                            </span>
                            <br>
                          </div>

                          <div v-if="item.documento_allegado">
                            <span class="font-weight-bold text-uppercase">
                              Documento:
                            </span>
                            <span>
                              {{item.documento_allegado}}
                            </span>
                            <br>
                          </div>

                          <div v-if="item.parentezco_allegado">
                            <span class="font-weight-bold text-uppercase">
                              Parentesco:
                            </span>
                            <span>
                              {{item.parentezco_allegado}}
                            </span>
                            <br>
                          </div>

                        </v-card-text>
                      </v-card>
                    </div>

                  </div>

                </section>

                <section class="my-5 section-preview">

                  <h2 class="h1-responsive text-center font-weight-bold text-uppercase my-5">
                    5. Sobre la representación legal
                  </h2>

                  <div class="h1-responsive my-5" v-if="editedItem.abogado_confianza">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                      ¿Cuenta usted con un abogado de confianza que lo represente en el proceso?
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.abogado_confianza}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.abogado_confianza == 'Si' && ( (editedItem.nombre_abogado || editedItem.nombre2_abogado || editedItem.apellido1_abogado || editedItem.apellido2_abogado) || editedItem.direccion_abogado || editedItem.telefono_abogado)">

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.nombre_abogado || editedItem.nombre2_abogado || editedItem.apellido1_abogado || editedItem.apellido2_abogado">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                          Nombre del abogado:
                        </span>
                        <br>
                        <span style="padding: 10px;">

                          {{editedItem.nombre_abogado}}

                          <span v-if="editedItem.nombre2_abogado">
                            {{" " + editedItem.nombre2_abogado}}
                          </span>

                          {{" " + editedItem.apellido1_abogado}}

                          <span v-if="editedItem.apellido2_abogado">
                            {{" " + editedItem.apellido2_abogado}}
                          </span>

                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.direccion_abogado">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                          Dirección de notificación
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.direccion_abogado}}
                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.telefono_abogado">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                          Teléfono de contacto
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.telefono_abogado}}
                        </span>
                      </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.abogado_confianza == 'Si' && (editedItem.celular_abogado || editedItem.correo_abogado || editedItem.poder_abogado)">

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.celular_abogado">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                          Celular de contacto:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.celular_abogado}}
                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.correo_abogado">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                          Correo electrónico:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.correo_abogado}}
                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.poder_abogado">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                          Anexa poder especial:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.poder_abogado}}
                        </span>
                      </div>

                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                      Representado actualmente por la JEP:
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.representado_actualmente_jep}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'Si' && ( (editedItem.nombre_abogado || editedItem.nombre2_abogado || editedItem.apellido1_abogado || editedItem.apellido2_abogado) || editedItem.direccion_abogado || editedItem.telefono_abogado)">

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.nombre_abogado || editedItem.nombre2_abogado || editedItem.apellido1_abogado || editedItem.apellido2_abogado">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                        Nombre del abogado:
                      </span>
                      <br>
                      <span style="padding: 10px;">

                        {{editedItem.nombre_abogado}}

                        <span v-if="editedItem.nombre2_abogado">
                          {{" " + editedItem.nombre2_abogado}}
                        </span>

                        {{" " + editedItem.apellido1_abogado}}

                        <span v-if="editedItem.apellido2_abogado">
                          {{" " + editedItem.apellido2_abogado}}
                        </span>

                      </span>
                    </div>

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.direccion_abogado">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                        Dirección de notificación
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.direccion_abogado}}
                      </span>
                    </div>

                    <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.telefono_abogado">
                      <span class="font-weight-bold text-uppercase">
                        <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                        Teléfono de contacto
                      </span>
                      <br>
                      <span style="padding: 10px;">
                        {{editedItem.telefono_abogado}}
                      </span>
                    </div>

                  </div>

                  <div class="h1-responsive my-5" style="display:flex; justify-content: space-between" v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'Si' && (editedItem.celular_abogado || editedItem.correo_abogado)">

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.celular_abogado">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                          Celular de contacto:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.celular_abogado}}
                        </span>
                      </div>

                      <div class="estilo_tres_columnas" style="padding-left:0px;" v-if="editedItem.correo_abogado">
                        <span class="font-weight-bold text-uppercase">
                          <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                          Correo electrónico:
                        </span>
                        <br>
                        <span style="padding: 10px;">
                          {{editedItem.correo_abogado}}
                        </span>
                      </div>

                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'No' && editedItem.manifiesta_interes">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                      Manifiesta su interés en ser representado/a por un abogado común del Sistema Autónomo de Asesoría y Representación Legal de la JEP?
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.manifiesta_interes}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'No' && editedItem.manifiesta_interes == 'No' && editedItem.voluntad_actuar_solo">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                      Manifiesta su voluntad de actuar por sí mismo/a en el proceso ante la JEP?
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.voluntad_actuar_solo}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.abogado_confianza == 'No' && editedItem.representado_actualmente_jep == 'No' && editedItem.manifiesta_interes == 'No' && editedItem.voluntad_actuar_solo == 'No' && editedItem.medio_representacion">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">5.{{incrementarNumeral}}.</span> -->
                      Por favor, indique qué otro medio de representación judicial usará:
                    </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.medio_representacion}}
                    </span>
                  </div>

                </section>

                <section class="my-5 section-preview">

                  <h2 class="h1-responsive text-center font-weight-bold text-uppercase my-5">
                    6. Protección y seguridad
                  </h2>

                  <div class="h1-responsive my-5" v-if="editedItem.riesgo_seguridad">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                        ¿Las víctimas solicitantes tienen alguna razón para temer por su seguridad, integridad, dignidad o bienestar actualmente, o identifica riesgos por el inicio de este proceso de acreditación ante la Jurisdicción Especial para la Paz?
                      </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.riesgo_seguridad}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.razones_riesgo_seguridad">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                        ¿Cuáles son las razones?
                      </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.razones_riesgo_seguridad}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.riesgo_seguridad_pruebas">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                        ¿La víctima solicitante o sus familiares y/o allegados tienen alguna razón para temer por la seguridad o integridad o algún riesgo sobre la información, archivos, objetos o lugares que puedan representar interés probatorio o de información de contexto para el inicio de este proceso de acreditación ante la Jurisdicción Especial para la Paz?
                      </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.riesgo_seguridad_pruebas}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.razones_riesgo_seguridad_pruebas">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                        ¿Cuáles son las razones?
                      </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.razones_riesgo_seguridad_pruebas}}
                    </span>
                  </div>

                  <div class="h1-responsive my-5" v-if="editedItem.autoriza_notificacion">
                    <span class="font-weight-bold text-uppercase">
                      <!-- <span class="badge badge-pill badge-dark">6.{{incrementarNumeral}}.</span> -->
                        ¿Autoriza a ser notificado de las actuaciones de este caso por medios electrónicos?
                      </span>
                    <br>
                    <span style="padding: 10px;">
                      {{editedItem.autoriza_notificacion}}
                    </span>
                  </div>

                </section>

                <v-btn flat @click.native="step = 5">Anterior</v-btn>
                <v-btn color="primary" @click.prevent="save" v-if="boton_guardar">Guardar</v-btn>

            </v-form>

          </v-stepper-content>

        </v-stepper-items>

      </v-stepper>

    </div>
  </div>

</template>

<script>
  import { EventBus } from "../EventBus"
  import CargarDocumento from "../components/CargarDocumento"
  // import Alertifyjs from "vue2-alertifyjs"

  export default {
    data: () => ({
      step: 1,
      valid: true,
      dialog: false,
      dialog2: false,
      dialog3: false,
      boton_guardar:true,
      headers: [
        {text: "Nombre", value: "nombres"},
        // {text: "Identificación", value: "no_identificacion"},
        // {text: "Tarjeta profesional", value: "tarjeta_profesional"},
        // {text: "Departamento", value: "enfoques_abogados_id"},
        // {text: "Tipo", value: "tipos_abogados_id"},
        // {text: "Fecha fin contrato", value: "fecha_fin_contrato"},
        {text: "Estado", value: "activo"},
        {text: "Actions", value: "name", sortable: false},
      ],
      tableData: [],
      editedIndex: -1,
      numeral: 0,
      etnias:[],
      generos:[],
      indicativos:["4 - ANTIOQUIA","5 - ATLÁNTICO","1 - BOGOTÁ D.C.","5 - BOLÍVAR","8 - BOYACÁ","6 - CALDAS","8 - CAQUETÁ","2 - CAUCA","5 - CESAR","4 - CÓRDOBA","1- CUNDINAMARCA","4- CHOCO","8 - HUILA","5 - GUAJIRA","5 - MAGDALENA","8 - META","2 - NARIÑO","7 - NORTE DE SANTANDER","6 - QUINDÍO","6 - RISARALDA","7 - SANTANDER","5 - SUCRE","8 - TOLIMA","2 - VALLE DEL CAUCA","7 - ARAUCA","8 - CASANARE","8 - PUTUMAYO","8 - SAN ANDRÉS Y PROVIDENCIA","8 - AMAZONAS","8 - GUAINÍA","8 - GUAVIARE","8 VAUPÉS","8 - VICHADA"],
      calidades_ayuda:["Funcionario de la JEP","Funcionario del Ministerio Público","Funcionario de CRAV","Abogado del SAAD","Abogado de confianza","Familiar o allegado"],
      departamentos:["Boyacá","Santander"],
      municipios:["Tunja","Barbosa"],
      bloques:["BLOQUE CARIBE"],
      frentes:["FRENTE 19 JOSE PRUDENCIA PADILLA","FRENTE 35 ANTONIO JOSE DE SUCRE","FRENTE 37 BENKOS BIOHO","FRENTE 41 CACIQUE DE UPAR","FRENTE 59 RESISTENCIA GUAJIRA","RED URBANA JOSE ANTEQUERA"],
      documentos_requeridos:["Vigencia tarjeta profesional","Penales","Contravencionales","Disciplinarios CSJ", "Diciplinarios PGN"],
      abogado_reconocido_victima_principal: ["Sí", "No"],
      reconocimiento_personeria_juridica: ["No reconocida", "Reconocida"],
      menu_fecha_auto_reconocimiento_personeria_juridica: false,
      menu_fecha_auto_reconocimiento_personeria_juridica_allegado: false,
      sexos:[],
      tipo_documentos:[],
      src_departamentos:[],
      src_municipios:[],
      src_departamentos_nacimiento:[],
      src_municipios_nacimiento:[],
      src_frentes:[],
      src_bloques:[],
      src_departamentos_hechos:[],
      src_municipios_hechos:[],
      documento:"",
      departamento_nombre:"",
      item_departamento_nombre:"",
      departamento_municipio_nombre:"",
      item_departamento_municipio_nombre:"",
      departamento_hechos_nombre:"",
      item_departamento_hechos_nombre:"",
      municipio_nombre:"",
      item_municipio_nombre:"",
      municipio_municipio_nombre:"",
      item_municipio_municipio_nombre:"",
      municipio_hechos_nombre:"",
      item_municipio_hechos_nombre:"",
      nombreAdjunto:"",
      enfoques_abogado:[],
      tipos_abogado:[],
      menu:"",
      menu_fecha_titulo:[],
      menu_fecha_ingreso:[],
      menu_fecha_salida:[],
      menu_fecha_inicio_contrato:false,
      menu_fecha_fin_contrato:false,
      menu_fecha_nacimiento:false,
      num_docs:1,
      openFileDialog:[],
      date:"",
      items_educa:0,
      adjuntar_documentos:[],
      adjuntar_documentos_fa:[],
      file:{},
      selected_archivo:{},
      upload_success:false,
      upload_failed:false,
      spinner_on:false,
      documento: "",
      educa:{
        id:-1,
        universidad:"",
        grado:"",
        titulo:"",
        pais:"",
        pre_pos:"",
      },
      items_educa:0,
      pres_resp:{
        id:-1,
        nombre_responsable:"",
        nombre2_responsable:"",
        apellido1_responsable:"",
        apellido2_responsable:"",
        alias_responsable:"",
        bloque_id:"",
        frente_id:"",
        otro:"",
        observaciones:"",
      },
      docu_adjunto:{
        documento:"",
      },
      docu_adjunto_fa:{
        documento:"",
      },
      fami_alle:{
        id:-1,
        nombre_allegado:"",
        nombre2_allegado:"",
        apellido1_allegado:"",
        apellido2_allegado:"",
        documento_allegado:"",
        parentezco_allegado:"",
        adjunto_allegado:"",
      },
      editedItem: {
        solicitud_anterior: "",
        no_registro_victima: "",
        formulario_propio: "",
        persona_victima: "",
        nombre_victima_solicitante: "",
        nombre2_victima_solicitante: "",
        apellido1_victima_solicitante: "",
        apellido2_victima_solicitante: "",
        departamento_nacimiento_id: "",
        municipio_nacimiento_id: "",
        fecha_nacimiento: "",
        direccion: "",
        departamento_id: "",
        municipio_id: "",
        grupo_etnico: "",
        nombre_grupo_etnico: "",
        organizacion_victimas: "",
        nombre_organizacion_victimas: "",
        sujeto_colectivo: "",
        nombre_sujeto_colectivo: "",
        indicativo: "",
        telefono_fijo: "",
        telefono_celular: "",
        correo: "",
        ocupacion_actual: "",
        hecho_victimizante: "",
        victima_desaparecida: "",
        fecha_hechos_inicio: "",
        fecha_hechos_fin: "",
        departamento_hechos_id: "",
        municipio_hechos_id: "",
        lugar_hechos: "",
        abogado_confianza: "",
        nombre_abogado: "",
        nombre2_abogado: "",
        apellido1_abogado: "",
        apellido2_abogado: "",
        direccion_abogado: "",
        telefono_abogado: "",
        celular_abogado: "",
        correo_abogado: "",
        adjunto_poder_abogado: "",
        poder_abogado: "",
        representado_actualmente_jep: "",
        manifiesta_interes: "",
        voluntad_actuar_solo: "",
        medio_representacion: "",

        reconocimiento_personeria_juridica: "",
        auto_reconocimiento_personeria_juridica: "",
        fecha_auto_reconocimiento_personeria_juridica: "",
        nombre_abogado_reconocido: "",
        nombre2_abogado_reconocido: "",
        apellido1_abogado_reconocido: "",
        apellido2_abogado_reconocido: "",
        direccion_abogado_reconocido: "",
        telefono_abogado_reconocido	: "",
        celular_abogado_reconocido	: "",
        correo_abogado_reconocido: "",

        riesgo_seguridad: "",
        razones_riesgo_seguridad: "",
        riesgo_seguridad_pruebas: "",
        razones_riesgo_seguridad_pruebas: "",
        autoriza_notificacion: "",
        estado: "",
        tarjeta_profesional: "",
        tipos_abogados_id: 1,
        role:{},
        permissions:[],
        presuntos_responsables:[],
        allegados_familiares:[],
        files_to_upload:[],
        adjuntos:[],
        created_at: "",
      },
      defaultItem: {
        name: "",
        email: "",
        tarjeta_profesional: "",
        tipos_abogados_id: 1,
        role:{},
        permissions:[],
        presuntos_responsables:[],
        allegados_familiares:[],
        files_to_upload:[],
        adjuntos:[],
        created_at: "",
      },
      editedItemAllegado: {
        estado_allegado: "",
        observaciones_allegado: "",
        fecha_acreditacion_allegado: "",

        abogado_reconocido_victima_principal: "",
        reconocimiento_personeria_juridica_allegado: "",
        fecha_auto_reconocimiento_personeria_juridica_allegado: "",
        auto_reconocimiento_personeria_juridica_allegado: "",

        nombre_abogado_reconocido_allegado: "",
        nombre2_abogado_reconocido_allegado: "",
        apellido1_abogado_reconocido_allegado: "",
        apellido2_abogado_reconocido_allegado: "",
        direccion_abogado_reconocido_allegado: "",
        telefono_abogado_reconocido_allegado: "",
        celular_abogado_reconocido_allegado: "",
        correo_abogado_reconocido_allegado: ""
      },
      rules: {
        required: value => !!value || "Este campo es obligatorio",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || "Correo Electrónico Invalido."
        },
        email_vacio: value => {
          const pattern =  /^[a-zA-Z0-9.!#$%&"*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
          return pattern.test(value) ||!value || "Correo Electrónico Invalido"
        },
        number_vacio: value => {
          const pattern =  /^\d+(\.\d)?$/
          return pattern.test(value) ||!value || "Este campo debe contener dígitos únicamente"
        },
      },
      requiredRules: [
        v => !!v || "Este campo es obligatorio",
        //v => /^\d+(\.\d)?$/.test(v) || "Número de documento debe contener dígitos únicamente"
      ],
    }),
    components:{
      "cargar-documento": CargarDocumento
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Registrar abogado" : "Editar abogado";
      },
      filteredTiposDocumentosXID: function () {
        var self = this
        return self.tipo_documentos.filter(function (item_tipo_documento) {
          return item_tipo_documento.id === self.editedItem.tipos_documentos_id
        })
      }
      // incrementarNumeral () {
      //   this.numeral = this.numeral + 1;
      //   return this.numeral;
      // },
      // reinicioNumeral () {
      //   this.numeral = 0;
      //   this.numeral = this.numeral + 1;
      //   return this.numeral;
      // },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      "editedItem.fecha_hechos_fin":
      function (val){
        if(this.editedItem.fecha_hechos_inicio>this.editedItem.fecha_hechos_fin)
        {
          alert("La fecha final no puede ser anterior a la fecha inicial de los hechos.");
          this.editedItem.fecha_hechos_fin="";
        }
      },
      "editedItem.fecha_hechos_inicio":
      function (val){
        if(this.editedItem.fecha_hechos_inicio>"2016-12-31")
        {
          alert("La fecha inicial no puede ser posterior a 2016.");
          this.editedItem.fecha_hechos_inicio="";
        }
      },
      "editedItem.departamento_id":
      function (val){
        if(val)
        {
          this.item_departamento_nombre  = this.src_departamentos.find(item => item.id === val);
          // console.log(this.item_departamento_nombre.nombre);
          this.departamento_nombre = this.item_departamento_nombre.nombre;
        }
      },
      "editedItem.municipio_id":
      function (val){
        if(val)
        {
          this.item_municipio_nombre  = this.src_municipios.find(item => item.id === val);
          // console.log(this.item_municipio_nombre.nombre);
          this.municipio_nombre = this.item_municipio_nombre.nombre;
        }
      },
      "editedItem.departamento_nacimiento_id":
      function (val){
        if(val)
        {
          this.item_departamento_nacimiento_nombre  = this.src_departamentos_nacimiento.find(item => item.id === val);
          console.log(this.item_departamento_nacimiento_nombre.nombre);
          this.departamento_nacimiento_nombre = this.item_departamento_nacimiento_nombre.nombre;
        }
      },
      "editedItem.municipio_nacimiento_id":
      function (val){
        if(val)
        {
          this.item_municipio_nacimiento_nombre  = this.src_municipios_nacimiento.find(item => item.id === val);
          console.log(this.item_municipio_nacimiento_nombre.nombre);
          this.municipio_nacimiento_nombre = this.item_municipio_nacimiento_nombre.nombre;
        }
      },
      "editedItem.departamento_hechos_id":
      function (val){
        if(val)
        {
          this.item_departamento_hechos_nombre  = this.src_departamentos_hechos.find(item => item.id === val);
          // console.log(this.item_departamento_hechos_nombre.nombre);
          this.departamento_hechos_nombre = this.item_departamento_hechos_nombre.nombre;
        }
      },
      "editedItem.municipio_hechos_id":
      function (val){
        if(val)
        {
          this.item_municipio_hechos_nombre  = this.src_municipios_hechos.find(item => item.id === val);
          // console.log(this.item_municipio_hechos_nombre.nombre);
          this.municipio_hechos_nombre = this.item_municipio_hechos_nombre.nombre;
        }
      },
      "editedItem.formulario_propio":
      function (valor){
        this.reseteoDatosDiligenciador();
      },
      "editedItem.grupo_etnico":
      function (valor){
        this.editedItem.nombre_grupo_etnico = "";
      },
      "editedItem.organizacion_victimas":
      function (valor){
        this.editedItem.nombre_organizacion_victimas = "";
      },
      "editedItem.sujeto_colectivo":
      function (valor){
        this.editedItem.nombre_sujeto_colectivo = "";
      },
      "editedItem.abogado_confianza":
      function (valor){
        this.reseteoDatosAbogado();
        this.editedItem.representado_actualmente_jep = "";
        this.editedItem.manifiesta_interes = "";
        this.editedItem.voluntad_actuar_solo = "";
        this.editedItem.medio_representacion = "";
      },
      "editedItem.reconocimiento_personeria_juridica":
      function (valor){
        // this.reseteoDatosAbogado();
        // this.editedItem.representado_actualmente_jep = "";
        // this.editedItem.manifiesta_interes = "";
        // this.editedItem.voluntad_actuar_solo = "";
        // this.editedItem.medio_representacion = "";
      },
      "editedItem.representado_actualmente_jep":
      function (valor){
        this.reseteoDatosAbogado();
        this.editedItem.manifiesta_interes = "";
        this.editedItem.voluntad_actuar_solo = "";
        this.editedItem.medio_representacion = "";
      },
      "editedItem.manifiesta_interes":
      function (valor){
        this.editedItem.voluntad_actuar_solo = "";
        this.editedItem.medio_representacion = "";
      },
      "editedItem.voluntad_actuar_solo":
      function (valor){
        this.editedItem.medio_representacion = "";
      },
      "editedItem.riesgo_seguridad":
      function (valor){
        this.editedItem.razones_riesgo_seguridad = "";
      },
      "editedItem.riesgo_seguridad_pruebas":
      function (valor){
        this.editedItem.razones_riesgo_seguridad_pruebas = "";
      },

      // "editedItem.departamento_id": function (val){
      //
      //   if(this.editedItem.departamento_id){
      //     if(this.editedItem.departamento_id=="")
      //     {
      //      this.src_municipios=[];
      //      this.src_municipios.unshift({id:"",nombre:"Seleccione un valor.."})
      //     }
      //     else
      //     {
      //       console.log("municipio  1");
      //axios.get("/api/municipios/"+this.editedItem.departamento_id).then(response=>this.src_municipios=response.data.data);
      //     }
      //   }

      // },


      // "editedItem.departamento_hechos_id": function (val){
      //
      //   if(this.editedItem.departamento_hechos_id){
      //     if(this.editedItem.departamento_hechos_id=="")
      //     {
      //      this.src_municipios_hechos=[];
      //      this.src_municipios_hechos.unshift({id:"",nombre:"Seleccione un valor.."})
      //     }
      //     else
      //     {
      //        console.log("municipio hechos 1");
      //         axios.get("/api/municipios/"+this.editedItem.departamento_hechos_id).then(response=>this.src_municipios_hechos=response.data.data);
      //     }
      //   }
      //
      // }
    },
    created() {
      this.initialize();
    },
    mounted(){
      let vm = this

      // vm.$notify("TEST","success")
      this.num_docs=1;
      // EventBus.$on("file-upload-success", (id) => {
      //      this.openFileDialog[id]=false;
      //      // this.editedItem.adjunto_tarjeta_profesional=event.target.files[0];
      //      console.log(id);
      //    });
      EventBus.$on("file-to-upload", (file_to_upload,nombreAdj,tipoAdj) => {
        // this.openFileDialog=false;

        this.editedItem.files_to_upload[nombreAdj+" "+tipoAdj]=file_to_upload;
        // this.editedItem.this[nombreAdjunto]=file_to_upload;
        console.log("Archivo recibido = "+file_to_upload);
        // console.log(this.editedItem.this[nombreAdjunto]);
        console.log(this.editedItem);
        // this.no_upload[this.num_docs]=false;
      });

    },
    methods: {
      initialize() {

        //  this.editedItem.educacion.push(Object.assign({},this.educa));
        // this.editedItem.experiencia.push(Object.assign({},this.experiencia));
        // console.log(this.editedItem)
        axios.get("/api/atencion_victimas").then(response => {
          // console.log(response);
          this.tableData = response.data.data;
        });

        axios.get("/api/roles").then(response=>this.allRoles=response.data.data);
        axios.get("/api/permissions").then(response=>this.allPermissions=response.data.data);
        axios.get("/api/departamentos").then(response=>this.src_departamentos=response.data.data);
        axios.get("/api/departamentos").then(response=>this.src_departamentos_hechos=response.data.data);
        axios.get("/api/departamentos").then(response=>this.src_departamentos_nacimiento=response.data.data);
        axios.get("/api/bloques").then(response=>this.src_bloques=response.data.data);
        axios.get("/api/frentes").then(response=>this.src_frentes=response.data.data);
        // axios.get("/api/municipios").then(response=>this.src_municipios=response.data.data);
        axios.get("/api/tipo_documentos").then(response => {this.tipo_documentos=response.data.data;});


        // this.editedItem.presuntos_responsables.push(Object.assign({},this.pres_resp));
        // this.editedItem.allegados_familiares.push(Object.assign({},this.fami_alle));
        // this.adjuntar_documentos.push(Object.assign({},this.docu_adjunto));
        // this.adjuntar_documentos_fa.push(Object.assign({},this.docu_adjunto_fa));


        // this.$refs.form_step_1.reset()
        // this.$refs.form_step_2.reset()
        // this.$refs.form_step_3.reset()
        // this.$refs.form_step_4.reset()
        // this.$refs.form_step_5.reset()

        // axios.get("/api/tipo_documentos").then(response => {
        //   this.tipo_documentos=response.data.data;
        // });
        //
        // axios.get("/api/sexos").then(response => {
        //   this.sexos=response.data.data;
        // });
        //
        // axios.get("/api/generos").then(response => {
        //   this.generos=response.data.data;
        // });
        //
        // axios.get("/api/etnias").then(response => {
        //   this.etnias=response.data.data;
        // });
        //
        // axios.get("/api/enfoques_abogado").then(response => {
        //   this.enfoques_abogado=response.data.data;
        // });
        //
        // axios.get("/api/tipos_abogado").then(response => {
        //   this.tipos_abogado=response.data.data;
        // });

      },
      editItem(item) {
        this.editedIndex = this.tableData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      showItem(item) {
        this.editedIndex = this.tableData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog2 = true;
      },
      deleteItem(item) {
        const index = this.tableData.indexOf(item);
        confirm("Esta seguro que desea borrar el registro?") && this.tableData.splice(index, 1);
        axios.delete("/api/atencion_victimas/"+item.id).then(response=>console.log(response.data))
      },
      reseteoDatosDiligenciador () {
        this.editedItem.persona_victima = "";
        this.editedItem.calidad_ayuda = "";
      },
      reseteoDatosAbogado () {
        this.editedItem.nombre_abogado = "";
        this.editedItem.nombre2_abogado = "";
        this.editedItem.apellido1_abogado = "";
        this.editedItem.apellido2_abogado = "";
        this.editedItem.direccion_abogado = "";
        this.editedItem.telefono_abogado = "";
        this.editedItem.celular_abogado = "";
        this.editedItem.correo_abogado = "";
        this.editedItem.adjunto_poder_abogado = "";
        this.editedItem.poder_abogado = "";
      },
      gestionDespachoReconocimientoFamiliar(index, item) {
        // console.log("item");
        // console.log(item);
        this.editedIndexAllegado = index;
        // this.editedItemAllegado = Object.assign({}, item);
        this.editedItemAllegado = {
          ...item
        };
        // console.log("this.editedItemAllegado");
        // console.log(this.editedItemAllegado);
        this.dialog3 = true;
      },
      updateReconocimientoPesonaJuridicaAllegado () {
        this.editedItem.allegados_familiares[this.editedIndexAllegado] = { ...this.editedItemAllegado }
        // console.log(this.editedItem, this.editedIndexAllegado, this.editedItemAllegado)
        this.dialog3 = false;
      },
      obtenerNombreBloque (id) {
        return this.src_bloques.find(item => item.id === id).nombre;
      },
      obtenerNombreFrente (id) {
        return this.src_frentes.find(item => item.id === id).nombre;
      },
      // "editedItem.bloque_id":
      // function (val){
      //   if(val)
      //   {
      //   this.item_bloque_nombre  = this.src_bloques.find(item => item.id === val);
      //   // console.log(this.item_municipio_hechos_nombre.nombre);
      //   this.municipio_hechos_nombre = this.item_municipio_hechos_nombre.nombre;
      //   }
      // },
      // "editedItem.frente_id":
      // function (val){
      //   if(val)
      //   {
      //   this.item_frente_nombre  = this.src_frentes.find(item => item.id === val);
      //   // console.log(this.item_municipio_hechos_nombre.nombre);
      //   this.municipio_hechos_nombre = this.item_municipio_hechos_nombre.nombre;
      //   }
      // },
      verifica_identificacion() {
        axios.get("/api/verifica_identificacion/"+this.editedItem.no_identificacion).then((response) => {
          console.log(response);
          if(response.data==1)
          {
            alert("Ya ha sido registrada una Solicitud de Acreditación como víctima del caso No. 01 asociada a este número de identificación " + this.editedItem.no_identificacion + ". En caso de que no sea así, por favor comuníquese con nosotros remitiendo un correo a victimas.caso001@jep.gov.co");
            this.editedItem.no_identificacion="";
          }
        });
      },
      trae_municipio() {
        axios.get("/api/municipios/"+this.editedItem.departamento_id).then(response=>this.src_municipios=response.data.data);
      },
      trae_municipio_hechos() {
        axios.get("/api/municipios/"+this.editedItem.departamento_hechos_id).then(response=>this.src_municipios_hechos=response.data.data);
      },
      trae_municipio_nacimiento() {
        axios.get("/api/municipios/"+this.editedItem.departamento_nacimiento_id).then(response=>this.src_municipios_nacimiento=response.data.data);
      },
      email_igual() {
        if(this.editedItem.correo!=this.editedItem.correo_verificar)
        {
          alert("El correo eléctronico y la verificación deben coincidir.");
          this.editedItem.correo_verificar="";
        }
      },
      return_portal() {
        newFunction();
      },
      validate (form_s,next_step) {
        if (form_s.validate()) {
          this.step = next_step;
        }
      },
      add_pres_resp () {
        // this.items_educa++;
        this.editedItem.presuntos_responsables.push(Object.assign({},this.pres_resp));
      },
      less_pres_resp (index) {
        this.$delete(this.editedItem.presuntos_responsables,index);
      },
      add_allegados () {
        // this.items_educa++;
        this.editedItem.allegados_familiares.push(Object.assign({},this.fami_alle));
      },
      less_allegados (index) {
        this.$delete(this.editedItem.allegados_familiares,index);
      },
      add_documentos () {
        this.adjuntar_documentos.push(Object.assign({},this.docu_adjunto));
        // this.adjuntar_documentos++;
        // this.editedItem.allegados_familiares.push(Object.assign({},this.fami_alle));
      },
      less_documentos (index) {
        // this.$delete(this.editedItem.allegados_familiares,index);
        this.$delete(this.adjuntar_documentos,index);
      },
      add_documentos_fa () {
        this.adjuntar_documentos_fa.push(Object.assign({},this.docu_adjunto_fa));
        // this.adjuntar_documentos++;
        // this.editedItem.allegados_familiares.push(Object.assign({},this.fami_alle));
      },
      less_documentos_fa (index) {
        // this.$delete(this.editedItem.allegados_familiares,index);
        this.$delete(this.adjuntar_documentos_fa,index);
      },
      init_reg () {
        // this.items_educa++;
        // (!this.editedItem.educacion) ? this.editedItem.educacion = Object.assign({}, this.educa) : console.log("SI existe");;
        // this.editedItem.educacion = Object.assign({}, this.educa);
        // if(this.editedItem.educacion)
        // {
        //this.editedItem.educacion = {};
        this.editedItem.presuntos_responsables.push(Object.assign({},this.pres_resp));
        this.editedItem.allegados_familiares.push(Object.assign({},this.fami_alle));

        this.$refs.form_step_1.reset()
        this.$refs.form_step_2.reset()
        this.$refs.form_step_3.reset()
        this.$refs.form_step_4.reset()
        this.$refs.form_step_5.reset()
        //  }
        // (!this.editedItem.educacion)?this.editedItem.educacion.push(Object.assign({},this.educa));
      },
      agregar_documento(){
        this.openFileDialog[this.num_docs]=true;
        // console.log("el documento para open = "+documento);
        // this.openFileDialog[1]=true;
        this.num_docs++;
      },
      delete_skillset (id_set) {
        this.items_educa++;
      },
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      exportar_pdf(){
        var cont=0;

        Object.entries(this.editedItem.files_to_upload).forEach(([key, val]) => {
          console.log(key);          // the name of the current key.
          console.log(val);          // the value of the current key.
          this.file = val;

          // this.file = this.editedItem.files_to_upload["""+element+"""];
          this.editedItem.adjuntos[key]=this.file.name;

          // eval("this.editedItem."+key+" = this.file.name");
          // eval("this.editedItem.adjunto01 = this.file.name");
          // eval("dynamic" + i + " = val[i]");
          // var formData = new FormData();
          // formData.append("archivo", this.file);
          // formData.append("nombre_adjunto", key);
          // formData.append("identificacion", t);
          // console.log("A guardar = "+this.file.name);
          // axios.post("/api/uploadFile",formData).then(response=>console.log(response.data));
          cont++;
        });

        this.show_export_spinner=true;

        // axios({
        //     url: "/exportar_pdf",
        //     params:this.editedItem,
        //     method: "GET",
        //     responseType: "blob", // important
        //   }).then((response) => {
        //     console.log(response);
        //     // this.show_export_spinner=false;
        //     const url = window.URL.createObjectURL(new Blob([response.data], {type:"application/pdf"}));
        //      const link = document.createElement("a");
        //      link.href = url;
        //      link.setAttribute("download", "formulario_registro.pdf"); //or any other extension
        //      document.body.appendChild(link);
        //      link.click();
        //  })
        //     .catch((error)=>{
        //       this.show_export_spinner=false;
        //       console.log(error);
        //   });

        console.log("this.editedItem.id: ", this.editedItem.id);

        axios({
          url: "/guardar_pdf",
          params:{id: this.editedItem.id},
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          console.log(response);
          // this.show_export_spinner=false;
          const url = window.URL.createObjectURL(new Blob([response.data], {type:"application/pdf"}));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "formulario_registro.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error)=>{
          this.show_export_spinner=false;
          console.log(error);
        });
      },
      ver_pdf(){
        var cont=0;

        Object.entries(this.editedItem.files_to_upload).forEach(([key, val]) => {
          console.log(key);          // the name of the current key.
          console.log(val);          // the value of the current key.
          this.file = val;

          // this.file = this.editedItem.files_to_upload["""+element+"""];
          this.editedItem.adjuntos[key]=this.file.name;

          // eval("this.editedItem."+key+" = this.file.name");
          // eval("this.editedItem.adjunto01 = this.file.name");
          // eval("dynamic" + i + " = val[i]");
          // var formData = new FormData();
          // formData.append("archivo", this.file);
          // formData.append("nombre_adjunto", key);
          // formData.append("identificacion", t);
          // console.log("A guardar = "+this.file.name);
          // axios.post("/api/uploadFile",formData).then(response=>console.log(response.data));
          cont++;
        });

        this.show_export_spinner=true;

        axios({
          url: "/ver_pdf",
          params:this.editedItem,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          console.log(response);

        })
        .catch((error)=>{
          this.show_export_spinner=false;
          console.log(error);
        });
      },
      save() {

        if(this.editedItem.files_to_upload)
        {
          console.log("Si existe files_to_upload")
          Object.entries(this.editedItem.files_to_upload).forEach(([key, val]) => {
            console.log(key);          // the name of the current key.
            console.log(val);          // the value of the current key.
            this.file = val;
            // this.file = this.editedItem.files_to_upload["""+element+"""];

            var formData = new FormData();
            formData.append("archivo", this.file);
            formData.append("nombre_adjunto", key);
            formData.append("identificacion", this.editedItem.no_identificacion);
            console.log("A guardar = "+this.file.name);
            axios.post("/api/uploadFile",formData).then(response=>console.log(response.data));
          });

        }
        if (this.editedIndex > -1) {
          console.log("Entró a update");
          Object.assign(this.tableData[this.editedIndex], this.editedItem);

          axios.put("/api/atencion_victimas/"+this.editedItem.id,this.editedItem).then(response=>console.log(response.data));
        } else {
          console.log("Entró a save");

          if(this.editedItem.nombre_victima_solicitante != "" &&  this.editedItem.no_identificacion != "")
          {
            if(confirm("Se guardará y enviará la información recibida, una vez registrada no podrá ser modificada. ¿Desea enviar el formulario?"))
            {
              // console.log(this.editedItem)
              this.boton_guardar = false;
              axios.post("/api/atencion_victimas",this.editedItem).then(response=>{
                this.tableData.push(response.data.abogado);
                console.log(response.data.registro.id);
                alert("La información fue registrada, se ha generado un archivo PDF con la información de su formulario, por favor consérvelo.")
                this.editedItem.id = response.data.registro.id;
                this.exportar_pdf(); //probar bajandola detro del response del save de la siguiente linea
              });
            }
          }
          else
          {
            alert("Debe diligenciar la información obligatoria.")
            this.step=1;
          }
        }
        // this.close();
      },
    },
  };

</script>

<style lang="css" scoped>
  .estilo_jep {
    background-color: #0b121f;
  }

  .primary--text {
    color: red;
  }

  .section-preview {
    border: 1px solid #e0e0e0;
    padding: 15px;
  }

  *{ text-transform: none !important; }

  .estilo_dos_columnas {
    width: 50%;
    margin-left:5px;
    margin-top:5px;
  }

  .estilo_tres_columnas {
    width: 33%;
    padding-right:10px;
    padding-top:15px;
  }

  .theme--dark.v-stepper--vertical .v-stepper__content:not(:last-child) {
    border-left: 0px;
  }
</style>


function newFunction() {
  if(confirm("El diligenciamiento del formulario en línea de solicitud de acreditación, requiere su manifestación de voluntad expresa para adelantar el tramite. Dado que usted ha señalado que no tiene dicho interés, será direccionado a la pagina anterior para que verifique en qué consiste la solicitud de acreditación como víctima del Caso 01.")) {
    window.location="https://www.jep.gov.co";
  }
}
